import React, { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { useParams } from 'react-router-dom'
import s from './styles/StudentProfilePage.module.scss'
import { useStudentProfilePage } from './hooks/useStudentProfilePage'
import { useHeaderLeading } from 'shared/hooks/useHeaderLeading'
import { AppDetailIcon } from 'pages/ApplicationDetailsPage/icons/AppDetailIcon'
import PersonalData from './components/PersonalData/PersonalData'
import TabsProfile from './components/TabsProfile/TabsProfile'
import StudentFooterNav from './components/StudentFooterNav/StudentFooterNav'
import AssignActivityModal from 'widgets/AssignActivityModal/AssignActivityModal'
import { getStudentCareerInterests } from 'pages/Students/constants/studentCareerInterests'

const StudentProfilePage = observer(() => {
	const { studentId: rawStudentId } = useParams()
	const studentId = rawStudentId
		? decodeURIComponent(String(rawStudentId).trim())
		: null

	const {
		isLoading,
		error,
		currentStudent,
		prevStudent,
		nextStudent,
		goPrev,
		goNext,
		goBack,
		profileData,
		isLoadingProfile,
		profileError,
	} = useStudentProfilePage(studentId)

	const [isAssignActivityOpen, setIsAssignActivityOpen] = React.useState(false)
	const [isAssignEssayOpen, setIsAssignEssayOpen] = React.useState(false)

	const headerLeading = useMemo(
		() => (
			<button type="button" className={s.back} onClick={goBack}>
				<AppDetailIcon name="arrow_back" size={18} className={s.back__icon} />
				<span>Back</span>
			</button>
		),
		[goBack],
	)

	useHeaderLeading(headerLeading)

	const studentName = currentStudent?.name || 'Student'
	const careerInterests = useMemo(
		() => getStudentCareerInterests(currentStudent),
		[currentStudent],
	)

	return (
		<div className={s.page}>
			{isLoading && !currentStudent ? (
				<div className={s.state}>Loading...</div>
			) : error && !currentStudent ? (
				<div className={s.stateError}>{error}</div>
			) : !currentStudent ? (
				<div className={s.state}>Student not found</div>
			) : (
				<>
					{/* key forces a clean visual switch as soon as the URL student changes */}
					<div className={s.content} key={studentId}>
						<PersonalData
							studentData={currentStudent}
							isLoadingProfile={isLoadingProfile}
							profileError={profileError}
							onOpenAssignActivity={() => setIsAssignActivityOpen(true)}
							onOpenAssignEssay={() => setIsAssignEssayOpen(true)}
						/>
						<TabsProfile
							profileData={profileData}
							studentId={studentId}
							studentName={studentName}
							careerInterests={careerInterests}
							isLoadingProfile={isLoadingProfile}
						/>
					</div>
					<StudentFooterNav
						prevStudent={prevStudent}
						nextStudent={nextStudent}
						onPrev={goPrev}
						onNext={goNext}
					/>
					<AssignActivityModal
						isOpen={isAssignActivityOpen}
						onClose={() => setIsAssignActivityOpen(false)}
						selectedStudents={currentStudent ? [currentStudent] : []}
						clearSelectionOnOpen={false}
						lockRecipients
					/>
					<AssignActivityModal
						isOpen={isAssignEssayOpen}
						onClose={() => setIsAssignEssayOpen(false)}
						selectedStudents={currentStudent ? [currentStudent] : []}
						clearSelectionOnOpen={false}
						lockRecipients
						tepeModal="applications"
						initialAssignmentType="Essay"
					/>
				</>
			)}
		</div>
	)
})

export default StudentProfilePage
